<template>
  <div class="AdelantosNominaAdministrativo">
    <md-table-card class="m-t-24">
      <md-toolbar>
        <h1 class="md-title">Empleados candidatos para adelanto de nómina</h1>
      </md-toolbar>
      <md-table>
        <md-table-header>
          <md-table-row>
            <md-table-head> # emp </md-table-head>
            <md-table-head> Nombre </md-table-head>
            <md-table-head> Puesto </md-table-head>
            <md-table-head> Punto </md-table-head>
            <md-table-head> </md-table-head>
          </md-table-row>
        </md-table-header>
        <md-table-body>
          <md-table-row v-for="empleado in empleados" :key="empleado.id_emn">
            <md-table-cell>{{empleado.id_emn}} </md-table-cell>
            <md-table-cell>{{empleado.nombre_empleado}} </md-table-cell>
            <md-table-cell>{{empleado.nombre_pue}} </md-table-cell>
            <md-table-cell>{{empleado.nombre_pun}} </md-table-cell>
            <md-table-cell>
              <md-input-container>
                <md-icon>attach_money</md-icon>
                <label>Importe</label>
                <md-input type="number" min="0" :max="empleado.salario_qnal_pnh" placeholder="Solicitó" @blur="hizoBlur(empleado.nombre_empleado,empleado.id_emn,empleado.salario_qnal_pnh,$event)"></md-input>
              </md-input-container>
            </md-table-cell>
          </md-table-row>
        </md-table-body>
      </md-table>
      <md-card-actions>
        <md-button class="md-raised md-primary" @click.native="guardarAdelantos()">Guardar</md-button>
      </md-card-actions>
    </md-table-card>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
export default {
  name: "AdelantosNominaAdministrativo",
  methods: {
    obtenerEmpleadosCandidatos() {
      this.$http
        .post("adelantos/pueden", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "empleados" in response.body) {
              this.empleados = response.body.empleados;
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    hizoBlur(nombre, empleado, tope, importe) {
      if (tope / 2 <= importe) {
        Snackbar.show({
          text:
            "A " +
            nombre +
            " se le ha asignado mas del 50% de su salario quincenal",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      }
      this.adelantos[empleado] = importe;
      console.log(this.adelantos);
    },
    guardarAdelantos() {
      this.$http
        .post("adelantos/guardar", {
          token: this.$session.get("token"),
          data: this.adelantos
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false
              });
              this.obtenerEmpleadosCandidatos();
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    } else if (this.$session.get("tipo") != "administrador") {
      this.$router.push("/");
    }
  },
  created() {
    this.obtenerEmpleadosCandidatos();
  },
  data() {
    return {
      valor: "",
      msg: "AdelantosNominaAdministrativo",
      empleados: [],
      adelantos: []
    };
  }
};
</script>


// WEBPACK FOOTER //
// AdelantosNominaAdministrativo.vue?5751b1e7